/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The IntegrationsbutterflyLabsButterflyLabsIntegration1 model module.
 * @module model/IntegrationsbutterflyLabsButterflyLabsIntegration1
 * @version v0.3
 */
export default class IntegrationsbutterflyLabsButterflyLabsIntegration1 {
  /**
   * Constructs a new <code>IntegrationsbutterflyLabsButterflyLabsIntegration1</code>.
   * @alias module:model/IntegrationsbutterflyLabsButterflyLabsIntegration1
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsbutterflyLabsButterflyLabsIntegration1</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsbutterflyLabsButterflyLabsIntegration1} obj Optional instance to populate.
   * @return {module:model/IntegrationsbutterflyLabsButterflyLabsIntegration1} The populated <code>IntegrationsbutterflyLabsButterflyLabsIntegration1</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsbutterflyLabsButterflyLabsIntegration1();
      if (data.hasOwnProperty('api_key'))
        obj.apiKey = ApiClient.convertToType(data['api_key'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} apiKey
 */
IntegrationsbutterflyLabsButterflyLabsIntegration1.prototype.apiKey = undefined;

/**
 * @member {Boolean} enabled
 */
IntegrationsbutterflyLabsButterflyLabsIntegration1.prototype.enabled = undefined;

